import { Injectable } from '@angular/core';
import { catchError, Observable, Observer, retry, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SseService {
  private readonly MAX_RETRIES = 30;
  private readonly RETRY_INTERVAL = 10000;

  getServerSentEvent(url: string): Observable<MessageEvent> {
    return new Observable((observer: Observer<MessageEvent>) => {
      const eventSource: EventSource = new EventSource(url);

      eventSource.onmessage = (event: MessageEvent) => {
        observer.next(event);
      };

      eventSource.onerror = (error: Event) => {
        observer.error(error);
      };

      return () => {
        eventSource.close();
      };
    }).pipe(
      retry({
        count: this.MAX_RETRIES,
        delay: this.RETRY_INTERVAL,
        resetOnSuccess: true,
      }),
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }
}
